import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import moment from 'moment';
import fitPrizesServices from '../../../../../services/fit-prizes.services';
import LegacyPrizesItemForm from '../form/LegacyPrizesItemForm';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const LegacyPrizesItemModal = ({ open, handleClose }) => {
  const params = useParams();
  const { watch, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();

  const { mutate: createLegacyPrizesItem } =
    fitPrizesServices.useMutationCreateLegacyPrizesItem(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-prizes-item'],
        refetchType: 'all',
      });
      AlertSuccess('เพิ่มข้อมูลสำเร็จ');
      handleClose();
    });

  const { mutate: editLegacyPrizesItem } =
    fitPrizesServices.useMutationUpdateLegacyPrizesItem(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-prizes-item'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      handleClose();
    });

  const _HandleSubmit = handleSubmit((data) => {
    const legayPrizesData = {
      imageUrl: data.imageUrl,
      title: data.title,
      type: data.type,
      active: data.active,
      callBackUrlType: data.callBackUrlType,
      callBackUrl: data.callBackUrl,
      startDate: moment(data.startDate).toDate(),
      endDate: moment(data.endDate).toDate(),
      giftEventId: params.giftEventId,
    };

    if (watch('formType') === 'create') {
      createLegacyPrizesItem(legayPrizesData);
    } else if (watch('formType') === 'edit') {
      editLegacyPrizesItem({ id: data.id, data: legayPrizesData });
    }
  });

  return (
    <Modal
      title={
        watch('formType') === 'create'
          ? 'เพิ่ม Legacy Prizes Item'
          : 'แก้ Legacy Prizes Item'
      }
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <LegacyPrizesItemForm />
    </Modal>
  );
};

export default LegacyPrizesItemModal;
